import React, { useEffect } from 'react';
import Navbar from './navbar/index';
import { snapshotContactStorage, restoreContactStorage } from '../utils/flightSearchDetails';

const ThankYou = () => {
    // Google Analytics conversion tracking
    useEffect(() => {
        // Wait for gtag to be available
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'conversion', {
                'send_to': 'AW-17772028476/7LmfCLmwv88bELzErppC',
                'value': 1.0,
                'currency': 'PKR'
            });
        } else {
            // If gtag is not immediately available, wait a bit and try again
            const timer = setTimeout(() => {
                if (window.gtag) {
                    window.gtag('event', 'conversion', {
                        'send_to': 'AW-17772028476/7LmfCLmwv88bELzErppC',
                        'value': 1.0,
                        'currency': 'PKR'
                    });
                }
            }, 500);
            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <div className='w-full'>
            <Navbar bg={1} />
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full text-center">
                    <h1 className="text-4xl font-bold text-secondary">Thank You!</h1>
                    <p className="mt-4 text-lg text-gray-600">
                        Booking has been submitted, one of our agents will call you shortly.
                        For quick response, please call: (03338820922)
                    </p>
                    <div className="mt-6">
                        <button
                            className="px-6 py-3 bg-secondary text-white rounded-md hover:bg-black transition duration-300"
                            onClick={() => {
                                const preservedContact = snapshotContactStorage();
                                localStorage.clear();
                                restoreContactStorage(preservedContact);
                                window.location.href = '/';
                            }}
                        >
                            Go Back
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ThankYou;
